import React from 'react';

export default class AccrualSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        const self = this;
        const userRole = this.props.userRole;
        const isMobile = this.isIos() || this.isAndroid();
        const lblHrs = isMobile? "Hrs" : "Hours";
        
        const accrualSummary = (this.props.accrualSummary ?? [])
            .filter(o => o.isVisibleToUser === true)
            .sort((o) => o.accrualDescription);
        
        let content = [];
        if (accrualSummary == null || accrualSummary.length == 0) {
            content.push(
                <div className="row ap-accrual-summary-item" key="sl_empty">
                    <div className="col-xs-12 col-md-12 ap-text-center">
                        No records found.
                    </div>
                </div>);
        }
        else {
            for (let i = 0; i < accrualSummary.length; i++) {
                let item = accrualSummary[i];

                content.push(
                    <div className="row ap-accrual-summary-item" key={item.accrualCode + "_" + i}>
                        <div className="col-xs-3 col-md-3 ap-text-bold text-left">
                            {item.accrualDescription}
                        </div>
                        <div className="col-xs-4 col-md-3">
                            {item.totalAccruedHours}
                        </div>
                        <div className="col-xs-2 col-md-2">
                            {item.loggedHours}
                        </div>
                        <div className="col-xs-3 col-md-2 ap-text-bold">
                            {item.availableHours}
                        </div>
                        <div className={userRole == "supervisor"? "ap-hidden" : "hidden-xs col-md-2 button-panel"}>
                            <button className="btn btn-selected" onClick={() => self.props.createPto(item.oaTimeOffCategoryCode)}>
                                <i className="fa fa-send ap-mr-1"></i>Request {item.oaTimeOffCategoryDescription}
                            </button>
                        </div>
                    </div>
                );
            }
        }

        return (
            <div className="col-xs-12 col-md-12 ap-accrual-summary">
                <div className="row ap-accrual-summary-title">
                    <div className="col-xs-12 col-md-12">
                        {this.props.title}
                    </div>
                </div>
                {
                    accrualSummary.length > 0 &&
                    <div className="row ap-accrual-summary-header">
                        <div className="col-xs-3 col-md-3">
                            {isMobile? "Type" : "Type of Time-Off"}
                        </div>
                        <div className="col-xs-4 col-md-3" title="When the Max Available is reached, the column reflects Accrued plus Carry, maxed at the limit, plus a credit for any hour taken in the current year">
                            {`Total Accrued/Carry ${lblHrs}`}
                        </div>
                        <div className="col-xs-2 col-md-2">
                            {`Taken ${lblHrs}`}
                        </div>
                        <div className="col-xs-3 col-md-2">
                            {`Available ${lblHrs}`}
                        </div>
                        <div className="hidden-xs col-md-2">
                        </div>
                    </div>
                }
                <div className="row">
                    <div className={isMobile? "col-xs-12" : "col-md-12 item-container"}>
                        {content}
                    </div>
                </div>
            </div>
            );
    }
}
